import { useEffect, useState } from "react"
import { Loader2, AlertTriangle, Home } from "lucide-react"

function Checkout() {
  const [show404, setShow404] = useState(false)

  const urlParams = new URLSearchParams(window.location.search)
  const redirectUrl = urlParams.get("redirect")
  const planType = urlParams.get("plan")

  useEffect(() => {
    if (!redirectUrl || !planType) {
      setShow404(true)
      return
    }

    const timer = setTimeout(() => {
      window.location.href = redirectUrl
    }, 1500)

    return () => clearTimeout(timer)
  }, [redirectUrl, planType])

  if (show404) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/30 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 text-center">
            <div className="w-20 h-20 mx-auto mb-6 relative">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
                <AlertTriangle className="w-10 h-10 text-red-600" />
              </div>
            </div>

            <h2 className="text-2xl font-black text-gray-900 mb-3">
              Pagina niet gevonden
            </h2>
            <p className="text-gray-600 mb-6">
              Deze pagina is alleen toegankelijk via de selectie van een abonnement.
            </p>

            <button
              onClick={() => window.location.href = '/'}
              className="w-full bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white font-bold py-3 px-6 rounded-xl hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
            >
              <Home className="w-5 h-5" />
              Terug naar home
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/30 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 text-center">
          <div className="w-20 h-20 mx-auto mb-6 relative">
            <div className="absolute inset-0 rounded-full border-4 border-[#00d4ff]/20"></div>
            <div className="absolute inset-0 rounded-full border-4 border-[#00d4ff] border-t-transparent animate-spin"></div>
            <Loader2 className="w-8 h-8 text-[#00d4ff] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
          </div>

          <h2 className="text-2xl font-black text-gray-900 mb-3">
            Je bestelling wordt voorbereid
          </h2>
          <p className="text-gray-600 mb-6">
            Even geduld...
          </p>

          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-gradient-to-r from-[#00d4ff] to-[#090979] h-2 rounded-full animate-pulse" style={{width: '100%'}}></div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 shadow-lg">
            <p className="text-sm text-gray-500">
              Automatische doorverwijzing bezig...
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Checkout